import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetPublishedAssessmentActivitiesByVersionQuery,
  GetPublishedAssessmentActivitiesByVersionQueryVariables,
} from './get-published-assessment-activities-by-version.graphql.generated';
import { GET_PUBLISHED_ASSESSMENT_ACTIVITIES_BY_VERSION } from './get-published-assessment-activities-by-version.graphql';
import { InquisitiveLanguageCodes } from 'global/graphql/scalars.type';

export const useGetPublishedAssessmentActivitiesByVersion = ({
  version,
  skip,
  fetchPolicy,
  isSignedIn,
  language,
  classId,
  onCompleted,
}: {
  version?: string | null;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
  isSignedIn: boolean;
  language?: InquisitiveLanguageCodes;
  classId?: number | null;
  onCompleted?: (res: GetPublishedAssessmentActivitiesByVersionQuery) => void;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetPublishedAssessmentActivitiesByVersionQuery,
    GetPublishedAssessmentActivitiesByVersionQueryVariables
  >(
    GET_PUBLISHED_ASSESSMENT_ACTIVITIES_BY_VERSION,
    {
      fetchPolicy,
      skip: !version || skip,
      variables: {
        input: {
          version: version || '',
          language,
          classId: classId ?? null,
        },
      },
      onCompleted: res => onCompleted?.(res),
    },
    isSignedIn
  );

  return {
    data,
    loading,
    error,
  };
};
